<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field v-model="editedItem.PLACENAME" :label="$t('eventplace_col1')"></v-text-field>
              </v-row>
              <v-row dense> 
                <v-textarea 
                  counter="100" v-model="editedItem.PLACEDESC" 
                  :label="$t('common_userinfo_label16')" value="" outlined :rules="[ v => (v.length <= 100) || $t('eventplace_label1') ]"></v-textarea>
              </v-row>
              
              <v-row dense>
                  <v-text-field :rules="[v => !v || !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(v) || $t('common_engrule')]" outlined :label="$t('eventplace_col4')"
                  v-model="editedItem.ACCNT">
                  </v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="editedItem.PW" outlined :label="$t('eventplace_col5')"
                 ></v-text-field>
              </v-row>

              <v-row dense> 
                <v-text-field hide-details v-model="editedItem.MSG1" :label="$t('eventplace_label2')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <comcolor dense :style="`color:#${editedItem.COLOR1}`" :comname="$t('design_label17')" :colorvalue="editedItem.COLOR1" @callback="textcolorcallback1" />
              </v-row>

              <v-row dense> 
                <v-text-field hide-details v-model="editedItem.MSG2" :label="$t('eventplace_label3')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <comcolor dense :style="`color:#${editedItem.COLOR2}`" :comname="$t('design_label17')" :colorvalue="editedItem.COLOR2" @callback="textcolorcallback2" />
              </v-row>

              <v-row dense> 
                <v-text-field v-model="editedItem.KEY1" :label="$t('eventplace_excel10')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.KEY2" :label="$t('eventplace_excel11')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.KEY3" :label="$t('eventplace_excel12')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.KEY4" :label="$t('eventplace_excel13')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.KEY5" :label="$t('eventplace_excel14')" outlined></v-text-field>
              </v-row>

              <v-row dense> 
                <v-select outlined hide-details v-model="editedItem.PLACE_TYPE" :items="PLACETYPELIST" :label="$t('eventplace_col3')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
              </v-row>

              <v-row dense class="mt-5"> 
                <v-select outlined hide-details v-model="editedItem.USE_LIMIT" :items="LIMITTYPELIST" :label="$t('eventplace_excel22')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" />
              </v-row>

              <v-row dense  align="center" justify="center" class="mt-5">
                <v-col cols="3">
                  <label>{{$t('eventplace_label4')}}</label><label style="color:red">*</label>
                </v-col>
                <v-col cols="9">
                  <v-file-input 
                    outlined dense height="43"
                    show-size :label="$t('eventplace_label5')" hide-details
                    v-model="uploadFile"
                    accept="image/png, image/jpeg"
                    @change="change_file"
                    >
                    </v-file-input>
                </v-col>
              </v-row>

              <v-row align="center" justify="center">
                <viewer
                  class="viewer"
                  ref="viewer" 
                  :options="options"
                  >
                  <img 
                    height="100" style="background:#808080;"
                    :src="previewImg"
                    class="image"
                    >
                </viewer>
              </v-row>                

              <!-- BARO 연동 -->
              <v-row dense v-if="grade > 90"> 
                <v-checkbox v-model="editedItem.USE_BARO" label="USE THE BARO"/>
              </v-row>
              <v-row dense v-if="grade > 90 && editedItem.USE_BARO"> 
                <v-text-field v-model="editedItem.BARO_APIKEY" label="BARO APIKEY" outlined></v-text-field>
              </v-row>
              <v-row dense v-if="grade > 90 && editedItem.USE_BARO"> 
                <v-text-field v-model="editedItem.BARO_PAGENAME" label="PAGE NAME" outlined></v-text-field>
              </v-row>
              <v-row dense v-if="grade > 90 && editedItem.USE_BARO"> 
                <v-text-field v-model="editedItem.BARO_ROWNUM" label="ROWNUM" outlined></v-text-field>
              </v-row>
              <v-row dense v-if="grade > 90 && editedItem.USE_BARO"> 
                <v-text-field v-model="editedItem.BARO_INIDX" label="PLACE IN IDX" outlined></v-text-field>
              </v-row>
              <v-row dense v-if="grade > 90 && editedItem.USE_BARO"> 
                <v-text-field v-model="editedItem.BARO_OUTIDX" label="PLACE OUT IDX" outlined></v-text-field>
              </v-row>


            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <!-- 이미지 크롭 팝업 (가로) -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog_land" @keydown.esc="crop_dialog_land = false" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="crop_dialog_land = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">
              <vueCropper
                ref="cropper_land"
                :img="imgSrc"
                :outputType="option.outputType"
                :fixed="option.fixed"
                :fixedNumber="option.fixedNumber"
                :full="option.full"
                :canMove="option.canMove"
                :canMoveBox="option.canMoveBox"
                :fixedBox="option.fixedBox"
                :original="option.original"
                :autoCrop="option.autoCrop"
                :autoCropWidth="option.autoCropWidth"
                :autoCropHeight="option.autoCropHeight"
                :centerBox="option.centerBox"
                :high="option.high"
                :infoTrue="option.infoTrue"
                :maxImgSize="option.maxImgSize"
                :enlarge="option.enlarge"
                :mode="option.mode"
                :limitMinSize="option.limitMinSize"
                />
            </div>
            <!-- 
            <vue-cropper
                ref="cropper_land"
                :aspectRatio="16/9"
                :src="imgSrc"
                preview=".preview"
                />
            -->
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="crop_dialog_land = false">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <!-- 엑셀수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="excelupdate_dialog" @keydown.esc="excelupdate_dialog = false" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('eul_label41')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="excelupdate_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-progress-linear :indeterminate="excel_prog"/>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field  v-model="SEARCH_COM_NAME" :label="$t('common_userinfo_label2')" disabled></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="SEARCH_EVENT_NAME" :label="$t('common_userinfo_label3')" disabled></v-text-field>
              </v-row>
              <v-row dense>
                <v-file-input
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                  :label="$t('eventinvit_label17')" v-model="uploadExcelFile" dense></v-file-input>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-btn class="dialog_cancel_btn mr-5" rounded large @click="excelupdate_dialog = false">{{$t("common_close")}}</v-btn>
                <v-btn rounded color="primary" @click="uploadUpdateExcel()">{{$t('eul_label12')}}</v-btn>  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>  
    </v-row>



    <v-row align="center" justify="start" dense>
      <v-col cols="12" md="3" sm="6" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>      
      <template v-if="grade >= 50">
      <v-col  cols="12" offset-md="1" md="3" sm="12" xs="12"  class="pa-0" align="center">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12"  class="pa-0" align="center">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>

      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="12" class="pa-0" align="end">

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#af1745" class="mr-3" elevation="1" small @click="excelupdate()"><v-icon>mdi-file-upload</v-icon></v-btn>
          </template>
          <span>{{$t('eventplace_msg11')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" style="color:#ffffff;background:#4e6ef7" class="mr-3" elevation="1" small @click="startDownload()"><v-icon>mdi-file-download</v-icon></v-btn>
          </template>
          <span>{{$t("common_downexcel")}}</span>
        </v-tooltip>

      </v-col>
    </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>

  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        item-key="IDX"
        :loading="loading"
        :items-per-page="9999"
        >
        <template v-slot:header.PLACENAME>
          <label class="cheader_normal" >{{$t("eventplace_col1")}}</label>
        </template>
        <template v-slot:header.PLACEDESC>
          <label class="cheader_normal" >{{$t("eventplace_col2")}}</label>
        </template>
        <template v-slot:header.PLACE_TYPE>
          <label class="cheader_normal" >{{$t("eventplace_col3")}}</label>
        </template>
        <template v-slot:header.USE_LIMIT>
          <label class="cheader_normal" >{{$t("eventplace_excel22")}}</label>
        </template>
        <template v-slot:header.ACCNT>
          <label class="cheader_normal" >{{$t("eventplace_col4")}}</label>
        </template>
        <template v-slot:header.PW>
          <label class="cheader_normal" >{{$t("eventplace_col5")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eventplace_col6")}}</label>
        </template>
                                                

        <template v-slot:item.PLACE_TYPE="{ item }">  
          <label>{{ item.PLACE_TYPE == 0 ? $t('eventplace_label6') : $t('eventplace_label7') }}</label>
        </template>     
        <template v-slot:item.USE_LIMIT="{ item }">  
          <label>{{ item.USE_LIMIT == 0 ? $t('inputbasic_label17') : $t('inputbasic_label18') }}</label>
        </template>     
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import 'cropperjs/dist/cropper.css';
import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리
import moment from 'moment'
import XLSX from 'xlsx'
export default {
    components:{
      VueCropper
    },
    data: () => ({
      
      excelupdate_dialog: false,
      excelItem: {},
      excel_prog: false,
      uploadExcelFile  : null,

      totalcnt : 0,       //전체 아이템 개수

      //필수 페이징 파라메터
      loading : false,    //로딩 표시
      s3: null,   //aws
      uploadFile  : null,
      FILEPATH1:"",       //s3에 새로운 이미지가 업로드된 경로
      selectFile:null,    //선택된 파일
      imgSrc:'',
      ratio: 16/9,
      crop_dialog_land: false,
      previewImg:'',

      //v-viewer옵션 이거해야 오류안남.
      options: {
        focus:false,
      },      

      //신규 크롭 파라메터
      option: {
        img: "",
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixed: true,          //크롭박스 비율 고정
        fixedNumber: [16,9],  //크롭박스 비율
        fixedBox: false,      //true면 크롭박스 크기 조절 안됨
        original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
        canMoveBox: true,
        autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
        autoCropWidth:400,    //크롭박스의 가로 크기 fixed가 true면 비율대로
        autoCropHeight:400,   //크롭박스의 세로 크기 
        centerBox: true,
        high: false,
        cropData: {},
				enlarge: 1,
        mode: 'contain',
        maxImgSize: 1500,
        limitMinSize: [300, 300]
      },      

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          PLACENAME:'',
          PLACEDESC:'',
          PLACE_TYPE:0,
          COLOR1:'000000',
          COLOR2:'ff0000',
          KEY1:'',
          KEY2:'',
          KEY3:'',
          KEY4:'',
          KEY5:'',
          USE_LIMIT:0,
          USE_BARO:0,
          BARO_APIKEY:null,
          BARO_PAGENAME:null,
          BARO_ROWNUM:null,
          BARO_INIDX:null,
          BARO_OUTIDX:null,

      },
      editedItem: {
      },
      

      //테이블 정의
      headers: [
        {text: '위치',    value: 'PLACENAME', sortable: true, align:'center' },
        {text: '설명',    value: 'PLACEDESC', sortable: true, align:'center'},
        {text: '타입',    value: 'PLACE_TYPE', sortable: true, align:'center'},
        {text: '차감',    value: 'USE_LIMIT', sortable: true, align:'center'},
        {text: '계정',    value: 'ACCNT', sortable: true, align:'center'},
        {text: '패스워드',    value: 'PW', sortable: true, align:'center'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],
      
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,
      
      PLACETYPELIST: [
          {name:'일반', name2:"Normal",    value:0}
        , {name:'필수', name2:"Required",  value:1}
      ],

      LIMITTYPELIST: [
          {name:'사용안함', name2:"Not Used",    value:0}
        , {name:'사용', name2:"Used",  value:1}
      ],

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.grade > 90){
        this.headers = [
          {text: 'IDX',    value: 'IDX', sortable: true, align:'center' },
          {text: '위치',    value: 'PLACENAME', sortable: true, align:'center' },
          {text: '설명',    value: 'PLACEDESC', sortable: true, align:'center'},
          {text: '타입',    value: 'PLACE_TYPE', sortable: true, align:'center'},
          {text: '차감',    value: 'USE_LIMIT', sortable: true, align:'center'},
          {text: '계정',    value: 'ACCNT', sortable: true, align:'center'},
          {text: '패스워드',    value: 'PW', sortable: true, align:'center'},
          {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
        ];
      }else{
        this.headers = [
          {text: '위치',    value: 'PLACENAME', sortable: true, align:'center' },
          {text: '설명',    value: 'PLACEDESC', sortable: true, align:'center'},
          {text: '타입',    value: 'PLACE_TYPE', sortable: true, align:'center'},
          {text: '차감',    value: 'USE_LIMIT', sortable: true, align:'center'},
          {text: '계정',    value: 'ACCNT', sortable: true, align:'center'},
          {text: '패스워드',    value: 'PW', sortable: true, align:'center'},
          {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
        ];
      }

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {


      textcolorcallback1(cl){
        this.editedItem.COLOR1 = String(cl).replace("#","").substring(0, 6);
      },      
      textcolorcallback2(cl){
        this.editedItem.COLOR2 = String(cl).replace("#","").substring(0, 6);
      },      

      //엑셀 데이터를 등록번호 기준으로 덮어쓰기
      uploadUpdateExcel(){
        
        if(this.uploadExcelFile == null){
          this.$alert(this.$t('eul_msg46'));
          return;
        }
        this.$confirm(this.$t('eventplace_msg16')).then(() => {
          
          this.excel_prog = true;
          const reader = new FileReader();
          
          reader.onload = ()=>{

            var fileData = reader.result;
            let workbook = XLSX.read(fileData, {type : 'binary'});  
            var sheetNameList = workbook.SheetNames; // 시트 이름 목록 가져오기 
            var firstSheetName = sheetNameList[0]; // 첫번째 시트명            
            var firstSheet = workbook.Sheets[firstSheetName]; // 첫번째 시트 
            let wrokjson = XLSX.utils.sheet_to_json(firstSheet, {defval:""});

            var uploaditem = [];
            wrokjson.forEach(element=>{
              uploaditem.push(element);
            })

            //계정 중복 체크 - 한글은 계정 영문은 ACCNT로 엑셀파일 컬럼을 읽는다.
            const accnts = uploaditem.map(item => item[this.$t('eventplace_msg21')]);

            //Set을 사용하여 중복 제거 후 배열로 변환
            const uniqueNames = [...new Set(accnts)];
            // 중복 체크
            const hasDuplicates = accnts.length !== uniqueNames.length;
            if(hasDuplicates){
              this.$alert(this.$t('eventplace_msg20'));
              this.excel_prog = false;
              return;
            }


            const deletedItems = this.itemList.filter(aItem => !uploaditem.some(bItem => bItem.IDX === aItem.IDX));
            //console.log("deletedItems : " + JSON.stringify(deletedItems));

            if(uploaditem.length < 1){
              this.$alert(this.$t('eul_msg48'));
              this.excel_prog = false;
              return;
            }

            //데이터 검증 
            var checkflag = true;
            
            const numberVal1 = /[^0-9]/g;
            //const mobileVal1 = /[^0-9-]/g;
            //const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

            for(var i=0;i<uploaditem.length;i++){
              if(!checkflag){
                break;
              }
              
              var element = uploaditem[i];
              if(element[this.$t('eventplace_excel4')] == null || String(element[this.$t('eventplace_excel4')]).length < 1){
                this.$alert(i+1+this.$t('eventplace_msg17'));
                checkflag = false;
                break;
              }
              if(String(element[this.$t('eventplace_excel4')]).length != 1){
                this.$alert(i+1+this.$t('eventplace_msg18'));
                checkflag = false;
                break;
              }              
              if(numberVal1.test(element[this.$t('eventplace_excel4')])){
                this.$alert(i+1+this.$t('eventplace_msg19'));
                checkflag = false;
                return;
              } 

            }

            if(!checkflag){
              this.uploadExcelFile = null;
              this.excel_prog = false;
              this.excelupdate_dialog = false;
              return;
            }

            //서버로 전송해서 처리
            this.$http.post(this.$host+'/api/EventPlaceExcelUpload',{
                JSONVALUE: escape(JSON.stringify(uploaditem))
              , DELETEVALUE: escape(JSON.stringify(deletedItems))
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , IDX_COLUMN: this.$t("eventplace_excel1")
              , PLACENAME_COLUMN: this.$t("eventplace_excel2")
              , PLACEDESC_COLUMN: this.$t("eventplace_excel3")
              , PLACETYPE_COLUMN: this.$t("eventplace_excel4")
              , PLACEACCNT_COLUMN: this.$t("eventplace_excel5")
              , PLACEPW_COLUMN: this.$t("eventplace_excel6")
              , PLACEMSG1_COLUMN: this.$t("eventplace_excel7")
              , PLACEMSG2_COLUMN: this.$t("eventplace_excel8")
              , PLACEIMG_COLUMN: this.$t("eventplace_excel9")
              , COLOR1_COLUMN: this.$t("eventplace_excel20")
              , COLOR2_COLUMN: this.$t("eventplace_excel21")
              , KEY1_COLUMN: this.$t("eventplace_excel10")
              , KEY2_COLUMN: this.$t("eventplace_excel11")
              , KEY3_COLUMN: this.$t("eventplace_excel12")
              , KEY4_COLUMN: this.$t("eventplace_excel13")
              , KEY5_COLUMN: this.$t("eventplace_excel14")
              , LAN_CODE:this.$i18n.locale
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.excel_prog   = false;
              this.excelupdate_dialog = false;
              if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                  this.$alert(this.$t('common_insert_msg')).then(()=>{
                    this.loadpage();
                  });

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                this.$alert(this.$t("common_insert_fail"));
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              this.excel_prog   = false;
              this.excelupdate_dialog = false;
              this.$alert(this.$t("common_insert_fail"));
            });

          }

          reader.readAsBinaryString(this.uploadExcelFile);  //비동기로 파일을 읽어서

        });


      },      


      startDownload(){

        this.$confirm(this.$t('eventplace_msg13')).then(() => {

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }

          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;
          this.$http.post(this.$host+'/api/EventPlaceListExcel',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , COM_IDX: this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                const list = result.data.resultData;
                //값이 없으면 빈값 1개 추가. 엑셀 양식 만들어 주기 위해서
                if(list.length == 0){
                  list.push({"A":"","B":"","C":"","D":"","E":"","F":"","G":"","H":"","I":"","J":"","K":"","L":"","M":"","N":"","O":"","P":"", "Q":""});
                }

                var item_sheet = XLSX.utils.json_to_sheet(list);
                
                //컬럼명 수정
                item_sheet.A1 = {v:this.$t('eventplace_excel1')};
                item_sheet.B1 = {v:this.$t('eventplace_excel2')};
                item_sheet.C1 = {v:this.$t('eventplace_excel3')};
                item_sheet.D1 = {v:this.$t('eventplace_excel4')};
                item_sheet.E1 = {v:this.$t('eventplace_excel5')};
                item_sheet.F1 = {v:this.$t('eventplace_excel6')};
                item_sheet.G1 = {v:this.$t('eventplace_excel7')};
                item_sheet.H1 = {v:this.$t('eventplace_excel8')};
                item_sheet.I1 = {v:this.$t('eventplace_excel9')};
                item_sheet.J1 = {v:this.$t('eventplace_excel20')};
                item_sheet.K1 = {v:this.$t('eventplace_excel21')};
                item_sheet.L1 = {v:this.$t('eventplace_excel22')};
                item_sheet.M1 = {v:this.$t('eventplace_excel10')};
                item_sheet.N1 = {v:this.$t('eventplace_excel11')};
                item_sheet.O1 = {v:this.$t('eventplace_excel12')};
                item_sheet.P1 = {v:this.$t('eventplace_excel13')};
                item_sheet.Q1 = {v:this.$t('eventplace_excel14')};

                //컬럼별 너비
                var wscols = [{wch:10},{wch:20},{wch:30},{wch:10},{wch:15,},{wch:15},{wch:20},{wch:20},{wch:20},{wch:20},{wch:20},{wch:20},{wch:20},{wch:20}];
                item_sheet['!cols'] = wscols;

                //타입 처리
                /*
                if (item_sheet['!ref']) {
                  var range = XLSX.utils.decode_range(item_sheet['!ref']); // 범위 디코딩
                  var numRows = range.e.r - range.s.r + 1; // 시작 행과 끝 행의 차이를 계산하여 행 수를 구함
                  for(var j=0;j<numRows;j++){
                    for(var k=0;k<16;k++){
                      var cell_ref1 = item_sheet[XLSX.utils.encode_cell({c:k, r:j})];
                      //이걸 해줘야 숫자를 010 식으로 입력해도 그대로 다 들어간다. 안해주면 010 입력시 10으로 변경됨.
                      cell_ref1.t = 's';  
                      cell_ref1.z = '@';  
                    }
                  }
                }
                */
               

                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, item_sheet, this.$t('eventplace_msg14'));
                XLSX.writeFile(wb, this.$t('eventplace_msg15')+moment().format('YYYYMMDDHHmmss')+'.xlsx');


            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

        });

      },      


      excelupdate(){
        this.uploadExcelFile = null;
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.excelItem = Object.assign({}, this.defaultItem)
        this.excelItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.excelItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.excelItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.excelItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.excelupdate_dialog = true;
      },                  


      change_file(){

        //파일명 백업
        this.selectFile = this.uploadFile.name;

        //이미지 크롭 팝업 띄우기
        const reader = new FileReader();
        reader.onload = (event)=>{
          //파일이 로드되면
          this.crop_dialog_land = true;       //크롭팝업 띄우고
          this.imgSrc = event.target.result;  //이게 blob데이터
        }
        reader.readAsDataURL(this.uploadFile);  //비동기로 파일을 읽어서
      },
      cropimg(){
        //이미지 크롭 
        this.$refs.cropper_land.getCropBlob(blob=>{
          this.crop_dialog_land = false;
          this.uploadFile = blob; //크롭된 이미지의 blob데이터
          this.$refs.cropper_land.getCropData(data=>{
            
            this.previewImg = data; //이미지뷰 미리보기용
            
            //갱신
            this.$forceUpdate();

          });
        });
      },            

      loadpage(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화

        this.loading = true;

          this.$http.post(this.$host+'/api/EventPlaceList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              list.forEach(element => {
                  this.itemList.push(element); 
              });
              this.totalcnt = this.itemList.length;
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //url의 마지막 /이후의 값을 가져온다.
      async getLastPath(path_url){
        var array = path_url.split('/');
        return array[array.length-1];
      },

      //추가 저장
      async save () {
        
        if(this.editedItem.PLACENAME  == undefined || this.editedItem.PLACENAME.length < 1){
          this.$alert(this.$t('eventplace_msg1'));
          return;
        } 

        if(this.editedItem.ACCNT  == undefined || this.editedItem.ACCNT.length < 1){
          this.$alert(this.$t('eventplace_msg2'));
          return;
        } 
        const accntValfirst = /^[a-z]/g;
        if(!accntValfirst.test(this.editedItem.ACCNT)){
          this.$alert(this.$t('eventplace_msg3'));
          return;
        }
        const accntvalidation = /^[a-z]+[a-z0-9]{3,29}$/g;
        if(!accntvalidation.test(this.editedItem.ACCNT)){
          this.$alert(this.$t('eventplace_msg4'));
          return;
        }

        const passVal = /^[a-zA-Z0-9!@#$%^&*()]{3,19}/;
        if(this.editedItem.PW  == undefined || this.editedItem.PW.length < 1 || this.editedItem.PW.length > 20){
          this.$alert(this.$t('eventplace_msg5'));
          return;
        } 
        if(!passVal.test(this.editedItem.PW)){
          this.$alert(this.$t('eventplace_msg6'));
          return;
        } 

        if(this.editedItem.MSG1  == undefined || this.editedItem.MSG1.length < 1){
          this.$alert(this.$t('eventplace_msg7'));
          return;
        } 
        if(this.editedItem.MSG2  == undefined || this.editedItem.MSG2.length < 1){
          this.$alert(this.$t('eventplace_msg8'));
          return;
        } 

        //배경 이미지
        var albumPhotosKey = encodeURIComponent("monitor") + "/";
        const cb_getLastPath = this.getLastPath;
        if(this.selectFile != null){
          var extens    = this.selectFile.split(".");
          let extension = extens[extens.length-1];
          var filename = Date.now().toString()+"_mtbg."+extension;
          var photoKey = albumPhotosKey + filename;   
          const temp_blob = this.uploadFile;
          const stored1 = await this.$s3.upload({
                                                Bucket: "blueorigin-mice-image",
                                                Key: photoKey,
                                                Body: temp_blob,
                                                ACL: "public-read"
                                              }).promise();
          this.FILEPATH1 = stored1.Location;

          //기존 이미지 제거
          if(this.editedItem.PLACEIMAGE != null && this.editedItem.PLACEIMAGE != undefined && this.editedItem.PLACEIMAGE.length > 0){
            var delete_filename = await cb_getLastPath(this.editedItem.PLACEIMAGE);
            var delete_photoKey = albumPhotosKey + delete_filename;
            await this.delete_image(delete_photoKey);
          }

        }

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/EventPlaceUpdate',{
                PLACENAME: escape(this.editedItem.PLACENAME)
              , PLACEDESC: this.editedItem.PLACEDESC == null || this.editedItem.PLACEDESC == undefined ? '' : escape(this.editedItem.PLACEDESC)
              , ACCNT: escape(this.editedItem.ACCNT)
              , PW: escape(this.editedItem.PW)
              , MSG1: this.editedItem.MSG1 == null || this.editedItem.MSG1 == undefined ? this.$t('eventplace_msg9') : escape(this.editedItem.MSG1)
              , MSG2: this.editedItem.MSG2 == null || this.editedItem.MSG2 == undefined ? this.$t('eventplace_msg9') : escape(this.editedItem.MSG2)
              , COLOR1: this.editedItem.COLOR1 != null && this.editedItem.COLOR1 != undefined ? this.editedItem.COLOR1 : '000000'
              , COLOR2: this.editedItem.COLOR2 != null && this.editedItem.COLOR2 != undefined ? this.editedItem.COLOR2 : 'FF0000'
              , KEY1: this.editedItem.KEY1 != null && this.editedItem.KEY1 != undefined ? escape(this.editedItem.KEY1) : ''
              , KEY2: this.editedItem.KEY2 != null && this.editedItem.KEY2 != undefined ? escape(this.editedItem.KEY2) : ''
              , KEY3: this.editedItem.KEY3 != null && this.editedItem.KEY3 != undefined ? escape(this.editedItem.KEY3) : ''
              , KEY4: this.editedItem.KEY4 != null && this.editedItem.KEY4 != undefined ? escape(this.editedItem.KEY4) : ''
              , KEY5: this.editedItem.KEY5 != null && this.editedItem.KEY5 != undefined ? escape(this.editedItem.KEY5) : ''
              , USE_LIMIT: this.editedItem.USE_LIMIT
              , USE_BARO: this.editedItem.USE_BARO
              , BARO_APIKEY: this.editedItem.BARO_APIKEY != null && this.editedItem.BARO_APIKEY != undefined ? this.editedItem.BARO_APIKEY : null
              , BARO_PAGENAME: this.editedItem.BARO_PAGENAME != null && this.editedItem.BARO_PAGENAME != undefined ? escape(this.editedItem.BARO_PAGENAME) : null
              , BARO_ROWNUM: this.editedItem.BARO_ROWNUM != null && this.editedItem.BARO_ROWNUM != undefined ? this.editedItem.BARO_ROWNUM : null
              , BARO_INIDX: this.editedItem.BARO_INIDX != null && this.editedItem.BARO_INIDX != undefined ? this.editedItem.BARO_INIDX : null
              , BARO_OUTIDX: this.editedItem.BARO_OUTIDX != null && this.editedItem.BARO_OUTIDX != undefined ? this.editedItem.BARO_OUTIDX : null

              , PLACE_TYPE: this.editedItem.PLACE_TYPE
              , FILEPATH1: this.FILEPATH1
              , IDX: this.editedItem.IDX
              , COM_IDX: this.editedItem.COM_IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              this.close();
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_edit_msg")).then(()=>{
                this.loadpage();
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else if(result.data.resultCode == 3){
              this.$alert(this.$t('eventplace_msg10'));

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/EventPlaceInsert',{
                PLACENAME: escape(this.editedItem.PLACENAME)
              , PLACEDESC: this.editedItem.PLACEDESC == null || this.editedItem.PLACEDESC == undefined ? '' : escape(this.editedItem.PLACEDESC)
              , FILEPATH1: this.FILEPATH1
              , ACCNT: escape(this.editedItem.ACCNT)
              , PW: escape(this.editedItem.PW)
              , MSG1: escape(this.editedItem.MSG1)
              , MSG2: escape(this.editedItem.MSG2)
              , COLOR1: this.editedItem.COLOR1 != null && this.editedItem.COLOR1 != undefined ? this.editedItem.COLOR1 : '000000'
              , COLOR2: this.editedItem.COLOR2 != null && this.editedItem.COLOR2 != undefined ? this.editedItem.COLOR2 : 'FF0000'
              , KEY1: this.editedItem.KEY1 != null && this.editedItem.KEY1 != undefined ? escape(this.editedItem.KEY1) : ''
              , KEY2: this.editedItem.KEY2 != null && this.editedItem.KEY2 != undefined ? escape(this.editedItem.KEY2) : ''
              , KEY3: this.editedItem.KEY3 != null && this.editedItem.KEY3 != undefined ? escape(this.editedItem.KEY3) : ''
              , KEY4: this.editedItem.KEY4 != null && this.editedItem.KEY4 != undefined ? escape(this.editedItem.KEY4) : ''
              , KEY5: this.editedItem.KEY5 != null && this.editedItem.KEY5 != undefined ? escape(this.editedItem.KEY5) : ''
              , USE_LIMIT: this.editedItem.USE_LIMIT
              , USE_BARO: this.editedItem.USE_BARO
              , BARO_APIKEY: this.editedItem.BARO_APIKEY != null && this.editedItem.BARO_APIKEY != undefined ? this.editedItem.BARO_APIKEY : null
              , BARO_PAGENAME: this.editedItem.BARO_PAGENAME != null && this.editedItem.BARO_PAGENAME != undefined ? escape(this.editedItem.BARO_PAGENAME) : null
              , BARO_ROWNUM: this.editedItem.BARO_ROWNUM != null && this.editedItem.BARO_ROWNUM != undefined ? this.editedItem.BARO_ROWNUM : null
              , BARO_INIDX: this.editedItem.BARO_INIDX != null && this.editedItem.BARO_INIDX != undefined ? this.editedItem.BARO_INIDX : null
              , BARO_OUTIDX: this.editedItem.BARO_OUTIDX != null && this.editedItem.BARO_OUTIDX != undefined ? this.editedItem.BARO_OUTIDX : null

              , PLACE_TYPE: this.editedItem.PLACE_TYPE
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              
              this.close();

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t('common_insert_msg')).then(()=>{
                this.loadpage();
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else if(result.data.resultCode == 3){
              this.$alert(this.$t('eventplace_msg10'));

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

      },      

      async delete_image(key){
        const temp = await this.$http.post(this.$host+'/api/DeleteImage',{deletekey:key},{headers:{accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}});
        return temp;
      },

      //검색
      search_run(){
        this.loadpage();
      },
      
      //신규 추가
      newinsert(){

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)

        this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.uploadFile = null;
        this.selectFile = null;
        this.previewImg = "";
        this.FILEPATH1 = "";
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.FILEPATH1  = this.editedItem.PLACEIMAGE; //수정시 전송할 파일명
        this.previewImg = this.editedItem.PLACEIMAGE; //미리보기
        this.uploadFile = null;
        this.selectFile = null;
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventPlaceDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
            , COM_IDX:item.COM_IDX
            , EVENT_IDX:item.EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          

      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>